export const PARTNERS_FETCHED = 'PARTNERS_FETCHED';
export const PARTNER_FETCHED = 'PARTNER_FETCHED';
export const PARTNER_ADDED = 'PARTNER_ADDED';
export const PARTNER_UPDATE = 'PARTNER_UPDATE';
export const PARTNER_KEYS_FETCHED = 'PARTNER_KEYS_FETCHED';
